import React from 'react'
import './awards.css'
import Heading from '../../../common/Heading'
import { awards } from '../../data/data'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import FavoriteIcon from '@mui/icons-material/Favorite';

const Awards = () => {
    return (
        <section className="awards padding">
            <div className="container">
                <Heading title='Over 1,24,000+ Happy User Bieng With Us Still They Love Our Services' subtitle='Our Awards' />
                <div className="content grid4 mtop">

                    <div className="box" >
                        <div className="icon">
                            <span><EmojiEventsIcon className='i' /></span>
                        </div>
                        <h1>32 M</h1>
                        <p>Blue Burmin Award</p>
                    </div>
                    <div className="box" >
                        <div className="icon">
                            <span><BusinessCenterIcon className='i' /></span>
                        </div>
                        <h1>43 M</h1>
                        <p>Mimo X11 Award</p>
                    </div>
                    <div className="box" >
                        <div className="icon">
                            <span><LightbulbIcon className='i' /></span>
                        </div>
                        <h1>51 M</h1>
                        <p>Australian UGC Award</p>
                    </div>
                    <div className="box" >
                        <div className="icon">
                            <span><FavoriteIcon className='i' /></span>
                        </div>
                        <h1>42 M</h1>
                        <p>IITCA Green Award</p>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default Awards
